import { render, staticRenderFns } from "./reels-downloader.vue?vue&type=template&id=5e70fd20&scoped=true"
import script from "./reels-downloader.vue?vue&type=script&lang=js"
export * from "./reels-downloader.vue?vue&type=script&lang=js"
import style0 from "./reels-downloader.vue?vue&type=style&index=0&id=5e70fd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70fd20",
  null
  
)

export default component.exports